import { createContext } from "react";

export const InventoriesContext = createContext(null); 